export const CPD_CREDIT_SECTIONS = [
  {
    key: "IA",
    label: "IA",
    fields: [
      { name: "IACredit", label: "IA Credit" },
      { name: "IAERCredit", label: "IAER Credit" },
      { name: "IAROCredit", label: "IA RO Credit" },
      { name: "IAILASCredit", label: "IA ILAS" },
    ],
  },
  {
    key: "MPF",
    label: "MPF",
    fields: [
      { name: "MPFCoreCredit", label: "MPF Core Credit" },
      { name: "MPFNonCoreCredit", label: "MPF Non-Core Credit" },
    ],
  },
  {
    key: "SFC",
    label: "SFC",
    fields: [
      { name: "SFCCredit", label: "SFC" },
      { name: "SFCECCredit", label: "SFC EC" },
    ],
  },
];

export const CPD_CREDIT_FIELDS = CPD_CREDIT_SECTIONS.flatMap(
  (section) => section.fields
);

export const createEmptyCpdDraft = () => ({
  dateEnroll: null,
  courseTitle: "",
  courseCode: "",
  IACredit: 0,
  IAERCredit: 0,
  IAROCredit: 0,
  IAILASCredit: 0,
  MPFCoreCredit: 0,
  MPFNonCoreCredit: 0,
  SFCCredit: 0,
  SFCECCredit: 0,
});

export const getCpdCreditTotal = (record) =>
  CPD_CREDIT_FIELDS.reduce(
    (sum, field) => sum + (Number(record?.[field.name]) || 0),
    0
  );
